export default function VenueName({ children, className }) {
	return (
		<div className="flex items-start w-full">
			<h1
				className={`min-h-[62px] text-darkGray font-outfit font-medium text-[19px] leading-[156%] tracking-[0.01em] hover:text-[#FE4747] line-clamp-2 ${className}`}
			>
				{children}
			</h1>
		</div>
	);
}
